import React, { useState } from "react";
import axios from "axios";
import { Modal, ToastContainer } from 'react-bootstrap';
import Hero from "../Components/Career/Hero";

const CareerForm = ({ departmentName }) => {
    // Form state
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    });
    const [show, setShow] = useState(false);

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [responseMessage, setResponseMessage] = useState("");

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent page refresh
        setIsSubmitting(true);
        setResponseMessage(""); // Clear previous response messages

        try {
            const response = await axios.post("https://api.example.com/submit-form", formData); // Replace with your API URL
            setResponseMessage(response.data.message || "Form submitted successfully!");
            setFormData({ name: "", email: "", message: "" }); // Reset form
        } catch (error) {
            setResponseMessage(
                error.response?.data?.message || "An error occurred while submitting the form."
            );
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleClose = () => {
        setShow(false);
        setFormData({
            item_id: "",
            emp_code: "",
            description: "",
            quantity: "",
            rate_per_item: "",
            purchase_date: null,
            // remaning_quantity: "",
            // distributed_quantity: "",
            // sub_company: sessionStorage.getItem('company_id')
        })
    }

    const handleShow = () => {
        // getProjects();
        // getEmployee();
        // getItem();
        setShow(true)
    };

    return (
        <>
            <button title="" className="flex items-center justify-center gap-2 bg-[#EFF3FC] rounded-md p-3 cursor-pointer " onClick={handleShow}>
                {departmentName}
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500    font-size-heading ">
                    <Modal.Title>{departmentName}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='max-sm:gap-2 max-sm:w-[90%] md:max-xl:w-[90%] w-[100%] relative flex flex-col items-center justify-center gap-8'>
                        <ToastContainer
                            newestOnTop
                            draggable
                            rtl={false}
                            theme="light"
                            autoClose={1500}
                            position="top-center"
                            pauseOnFocusLoss={false}
                        />
                        <div className="max-sm:text-3xl flex flex-col gap-2 text-4xl text-center justify-center" style={{ margin: "0px 0% 0 0" }}>
                            <div className='text-center flex items-end gap-2 font-bold'>
                                {/* Contact <span className="blue font-bold">Us</span> */}
                            </div>
                            {/* <div className="blue font-bold">SAPTAGON</div> */}
                        </div>

                        <form onSubmit={handleSubmit} className="max-sm:w-[95%] md:max-xl:w-[80%] w-[100%]   px-8   flex flex-col gap-8 ">
                            <div className="max-sm:gap-4 max-sm:flex-col flex items-center gap-12">

                                <div className='w-full flex flex-col gap-2'>
                                    <label htmlFor="name" className="text-sm font-medium text-gray-700">
                                        Full Name
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        required
                                        placeholder='Enter your Full Name'
                                        value={formData.name}
                                        onChange={handleChange}
                                        className="w-full px-4 py-2 bg-white border border-[#EDEEF1] rounded-md focus:border-[#8364C3] focus:ring-[#4FBECD] focus:outline-none focus:ring-1"
                                    />
                                </div>
                                <div className='w-full flex flex-col gap-2'>
                                    <label htmlFor="email" className="text-sm font-medium ">
                                        Email address
                                    </label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        required
                                        placeholder='Enter your email id'
                                        value={formData.email}
                                        onChange={handleChange}
                                        className="w-full px-4 py-2 bg-white border border-[#EDEEF1] rounded-md focus:border-[#8364C3] focus:ring-[#4FBECD] focus:outline-none focus:ring-1"
                                    />
                                </div>
                            </div>
                            <div className="max-sm:gap-4 max-sm:flex-col flex items-center gap-12">
                                <div className='w-full flex flex-col gap-2'>
                                    <label htmlFor="mobile" className="text-sm font-medium text-gray-700">
                                        Contact no.
                                    </label>
                                    <input
                                        type="number"
                                        id="mobile"
                                        name="mobile"
                                        required
                                        placeholder='Enter your Contact no.'
                                        value={formData.mobile}
                                        onChange={handleChange}
                                        className="w-full px-4 py-2 bg-white border border-[#EDEEF1] rounded-md focus:border-[#8364C3] focus:ring-[#4FBECD] focus:outline-none focus:ring-1"
                                    />
                                </div>
                                <div className='w-full flex flex-col gap-2'>
                                    <label htmlFor="destination" className="text-sm font-medium text-gray-700">
                                        Experience
                                    </label>
                                    <input
                                        type="text"
                                        id="exp"
                                        name="exp"
                                        required
                                        placeholder='Enter Your Subject'
                                        value={formData.subject}
                                        onChange={handleChange}
                                        className="w-full px-4 py-2 bg-white border border-[#EDEEF1] rounded-md focus:border-[#8364C3] focus:ring-[#4FBECD] focus:outline-none focus:ring-1"
                                    />

                                </div>

                                <div className='w-full flex flex-col gap-2'>
                                    <label htmlFor="destination" className="text-sm font-medium " style={{ marginLeft: "18px" }}>
                                      Resume
                                    </label>
                                    <input
                                        type="file"
                                        id="subject"
                                        name="subject"
                                        required
                                        placeholder='Enter Your Subject'
                                        value={formData.subject}
                                        onChange={handleChange}
                                        className="w-full px-4 py-2  rounded-md focus:border-[#8364C3] focus:ring-[#4FBECD] focus:outline-none focus:ring-1"
                                    />

                                </div>
                            </div>

                            <div className="flex flex-col items-start">
                                <label htmlFor="message" className="text-sm font-medium text-gray-700">
                                    Message
                                </label>
                                <textarea
                                    id="message"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    className="max-sm:min-h-[20vh] min-h-[25vh] resize-none w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md focus:border-[#8364C3] focus:ring-[#4FBECD] focus:outline-none focus:ring-1"
                                />
                            </div>
                            <div className='flex items-center justify-center'>
                                <button type='submit' className="px-6 py-2 mt-6 duration-500 text-white btn rounded-md focus:outline-none">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default CareerForm;
